import { Wallet } from "lucide-react";

const EmptyWalletState = ({ onCreate }: { onCreate: () => void }) => {
  return (
    <div className="flex flex-col items-center justify-center h-[60vh] text-center">
      <Wallet size={64} className="text-gray-400 dark:text-gray-600 mb-4" />

      <h3 className="text-lg font-semibold text-gray-800 dark:text-white/90 mb-2">
        You don’t have a wallet yet
      </h3>

      <p className="text-gray-500 dark:text-gray-400 mb-6">
        Create a wallet to start receiving and sending money.
      </p>

      <button
        onClick={onCreate}
        className="rounded-xl px-6 py-3
             bg-primary text-gray-800
             dark:bg-primary-dark dark:text-white
             hover:brightness-90 transition"
      >
        Create Wallet
      </button>
    </div>
  );
};

export default EmptyWalletState;
